// components/AdminUpdatesPanel.js
import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminUpdatesPanel = () => {
  const [updates, setUpdates] = useState([]);
  const [heading, setHeading] = useState("");
  const [content, setContent] = useState("");

  const fetchUpdates = () => {
    axios.get("https://backend.aubattle.com/api/updates")
      .then(res => setUpdates(res.data));
  };

  useEffect(() => {
    fetchUpdates();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post("https://backend.aubattle.com/api/updates", { heading, content })
      .then(() => {
        setHeading("");
        setContent("");
        fetchUpdates();
      });
  };

  const handleDelete = (id) => {
    axios.delete(`https://backend.aubattle.com/api/updates/${id}`).then(fetchUpdates);
  };

  return (
    <div className="container mt-4">
      <h3>🛠 Admin: Manage Important Updates</h3>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Heading</label>
          <input type="text" className="form-control" value={heading} onChange={(e) => setHeading(e.target.value)} required />
        </div>
        <div className="mb-3">
          <label>Description</label>
          <textarea className="form-control" value={content} onChange={(e) => setContent(e.target.value)} required />
        </div>
        <button type="submit" className="btn btn-primary">Post Update</button>
      </form>

      <hr />

      <h5>All Updates</h5>
      {updates.map((u) => (
        <div key={u.id} className="card my-2">
          <div className="card-body">
            <h5>{u.heading}</h5>
            <p>{u.content}</p>
            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(u.id)}>Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminUpdatesPanel;
